<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Company' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'general'" (click)="activeTab = 'general'">
          {{'General' | translate}}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'match'" (click)="activeTab = 'match'">
          {{'Match' | translate}}
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'followupdays'" (click)="activeTab = 'followupdays'">
          {{'Follow-up days' | translate}}
        </a>
      </li>
    </ul>

    <div class="tab-content">

      <div id="tab-general" class="tab-pane" [class.active]="activeTab === 'general'" [class.d-none]="activeTab !== 'general'">

        @if (formLoading()) {
        <div class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{'Loading...' | translate}}</span>
          </div>
        </div>
        } @else {
        <formly-form
          [model]="entity()"
          [fields]="generalFields"
          (modelChange)="onModelChange($event)"
        ></formly-form>

        <app-company-accounts-table
          [accounts]="companyAccounts()"
          (accountsChange)="companyAccounts.set($event)"
        ></app-company-accounts-table>
        }

      </div>

      <div id="tab-match" class="tab-pane" [class.active]="activeTab === 'match'" [class.d-none]="activeTab !== 'match'">

        <div class="alert alert-info">
          <fa-icon [icon]="icons.infoCircle"></fa-icon>
          {{'If you update the match criteria it can take up one day to get the correct (re-)calculated match results.' | translate}}
        </div>

        <div class="matchtcriteria-wrapper">

          <!-- competencies wrapper -->
          <div class="matchtest-competences-wrapper">

            <!-- competencies -->
            <div class="matchtest-competences-groups-wrapper">

              <!-- company culture -->
              <div class="matchtest-competence-group-wrapper">

                <h3>{{'Company culture' | translate}}</h3>

                <!-- factor company culture -->
                <div class="form-group row">
                  <label class="col-form-label col-sm-12">{{'Weighting percentage' | translate}}</label>
                  <div class="col-12 col-sm-6">
                    <div class="input-group">
                      <input class="form-control" type="number" (change)="onFactorChange('companyCultureFactor')" (keyup)="onFactorChange('companyCultureFactor')" [ngModel]="matchcriterion().companyCultureFactor" (ngModelChange)="updateMatchcriterionField('companyCultureFactor', $event)" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          %
                        </span>
                      </div>
                    </div>
                  </div>

                </div>

                <!-- selectable competencies company culture -->
                <div class="row">

                  <!-- selectable options go here -->
                  <div class="col-12 col-sm-6">

                    <p>{{'Select maximum 5 competences' | translate}}</p>

                    @for (competency of matchCompetencyCompanyCulture(); track competency.id) {
                    <!-- checkable option -->
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" [checked]="hasMatchtestCompetenceValue(competency.id!, 'companyCultureCompetencies')">
                      <label class="custom-control-label" (click)="toggleMatchtestCompetence(competency.id!, 'companyCultureCompetencies')">
                        {{competency.name | translate}}
                      </label>
                    </div>
                    }
                  </div>

                  <!-- selected values go here -->
                  <div class="col-12 col-sm-6">

                    <p>
                      {{'Sort the selected competences based on priority' | translate}}
                    </p>

                    <ul class="list-group">
                      @for (competencyMatchcriterion of matchcriterion().companyCultureCompetencies; track competencyMatchcriterion.matchCompetencyId; let key = $index) {
                      <li class="list-group-item d-flex flex-row justify-content-between">
                        <span class="text">
                          {{key + 1}}.
                          {{competencyMatchcriterion.name ?? '' | translate}}
                        </span>
                        <div class="btn-group">
                          <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyUp(key, 'companyCultureCompetencies')">
                            <fa-icon [icon]="icons.chevronUp"></fa-icon>
                          </button>
                          <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyDown(key, 'companyCultureCompetencies')">
                            <fa-icon [icon]="icons.chevronDown"></fa-icon>
                          </button>
                        </div>
                      </li>
                      }
                    </ul>

                  </div>

                </div>

              </div>

              <!-- personality culture -->
              <div class="matchtest-competence-group-wrapper mt-3">

                <h3>{{'Personality traits' | translate}}</h3>

                <!-- factor personality -->
                <div class="form-group row">
                  <label class="col-form-label col-sm-12">{{'Weighting percentage' | translate}}</label>
                  <div class="col-12 col-sm-6">
                    <div class="input-group">
                      <input class="form-control" type="number" (change)="onFactorChange('personalityFactor')" (keyup)="onFactorChange('personalityFactor')" [ngModel]="matchcriterion().personalityFactor" (ngModelChange)="updateMatchcriterionField('personalityFactor', $event)" />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          %
                        </span>
                      </div>
                    </div>
                  </div>

                </div>

                <!-- selectable competencies personality -->
                <div class="row">

                  <!-- selectable options go here -->
                  <div class="col-12 col-sm-6">

                    <p>{{'Select maximum 2 competences' | translate}}</p>

                    @for (competency of matchCompetencyPersonality(); track competency.id) {
                    <!-- checkable option -->
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" [checked]="hasMatchtestCompetenceValue(competency.id!, 'personalityCompetencies')">
                      <label class="custom-control-label" (click)="toggleMatchtestCompetence(competency.id!, 'personalityCompetencies')">
                        {{competency.name | translate}}
                      </label>
                    </div>
                    }
                  </div>

                  <!-- selected values go here -->
                  <div class="col-12 col-sm-6">

                    <p>
                      {{'Sort the selected competences based on priority' | translate}}
                    </p>

                    <ul class="list-group">
                      @for (competencyMatchcriterion of matchcriterion().personalityCompetencies; track competencyMatchcriterion.matchCompetencyId; let key = $index) {
                      <li class="list-group-item d-flex flex-row justify-content-between">
                        <span class="text">
                          {{key + 1}}.
                          {{competencyMatchcriterion.name ?? '' | translate}}
                        </span>
                        <div class="btn-group">
                          <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyUp(key, 'personalityCompetencies')">
                            <fa-icon [icon]="icons.chevronUp"></fa-icon>
                          </button>
                          <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyDown(key, 'personalityCompetencies')">
                            <fa-icon [icon]="icons.chevronDown"></fa-icon>
                          </button>
                        </div>
                      </li>
                      }
                    </ul>

                  </div>

                </div>

              </div>

            </div>

          </div>

          <!-- field of interest -->
          @if (areaOfInterests().length > 0) {
          <div class="matchtest-interests mt-4">

            <h3>{{'Field of interest' | translate}}</h3>

            <div class="form-group row">
              <label class="col-form-label col-12">{{'Weighting percentage' | translate}}</label>
              <div class="col-12 col-sm-6">
                <div class="input-group">
                  <input class="form-control" type="number" (change)="onFactorChange('areaOfInterestFactor')" (keyup)="onFactorChange('areaOfInterestFactor')" [ngModel]="matchcriterion().areaOfInterestFactor" (ngModelChange)="updateMatchcriterionField('areaOfInterestFactor', $event)" />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="entity-areaofinterests">

              <app-selector-areaofinterests [maxAmount]="15" [ngModel]="entity().areaOfInterests" (ngModelChange)="updateEntityField('areaOfInterests', $event)" [data]="areaOfInterests()"></app-selector-areaofinterests>

            </div>

          </div>
          }

          <!-- education levels -->
          <div class="matchtest-educationlevel mt-4">

            <h3>{{'Education levels' | translate}}</h3>

            <formly-form
              [model]="eduLevelsModel()"
              [fields]="eduLevelFields"
              [form]="eduLevelsForm"
              (modelChange)="onEduLevelsChange($event)">
            </formly-form>

          </div>

        </div>

      </div>

      <div id="tab-followupdays" [class.d-none]="activeTab !== 'followupdays'">

        <app-experience-days-table
          [experienceDays]="experienceDays()"
          [company]="entity()"
          [loading]="experienceDaysLoading()"
          (refresh)="getCompanyExperiencedays(entity().id!)"
        ></app-experience-days-table>

      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
